import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import data from '../sample/data';
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

function BlogPage() {
  const [query, setQuery] = useState('');
  const [activeTag, setActiveTag] = useState('all');
  const posts = data.blogs;

  const allTags = useMemo(() => {
    const set = new Set();
    posts.forEach(p => (p.tags || []).forEach(t => set.add(t)));
    return ['all', ...Array.from(set).sort()];
  }, [posts]);

  const filtered = useMemo(() =>
    posts
      .filter(p =>
        (activeTag === 'all' || (p.tags || []).includes(activeTag)) &&
        (
          p.title.toLowerCase().includes(query.toLowerCase()) ||
          p.excerpt.toLowerCase().includes(query.toLowerCase())
        )
      )
      .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0))
  , [posts, query, activeTag]);

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <h2 className="text-3xl font-bold">My Blog</h2>
        <div className="flex flex-col md:flex-row items-start md:items-center gap-3">
          <input
            className="px-4 py-2 rounded-lg bg-white/5 border border-white/10 focus:outline-none w-full md:w-64"
            placeholder="Search posts..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className="flex flex-wrap gap-2 mt-2 md:mt-0">
            {allTags.map(tag => (
              <button
                key={tag}
                onClick={() => setActiveTag(tag)}
                className={`px-3 py-1 rounded-full text-sm border ${
                  activeTag === tag
                    ? 'bg-accent text-white border-accent'
                    : 'border-white/10 hover:bg-white/5'
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((post) => (
          <Link
            key={post.id}
            to={`/blog/${post.id}`}
            className="group rounded-xl overflow-hidden border border-white/10 bg-white/5 hover:shadow-lg transition-shadow duration-300"
          >
            <article>
              <img
                src={post.image}
                alt={post.title}
                className="h-48 w-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 space-y-2">
                <div className="flex items-center justify-between text-xs text-foreground/70">
                  <span>{post.date ? new Date(post.date).toLocaleDateString() : ''}</span>
                  <div className="flex gap-2 flex-wrap">
                    {(post.tags || []).map(tag => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-full bg-white/10 border border-white/10 text-xs"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <h3 className="font-semibold group-hover:text-accent transition-colors text-lg">
                  {post.title}
                </h3>
                <p className="text-sm text-foreground/80 line-clamp-3">{post.excerpt}</p>
                <div className="text-accent text-sm font-medium mt-2">Read more →</div>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default BlogPage;
